import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=6e5d7eb5&scoped=true&"
import script from "./vipList.vue?vue&type=script&lang=js&"
export * from "./vipList.vue?vue&type=script&lang=js&"
import style0 from "./vipList.vue?vue&type=style&index=0&id=6e5d7eb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d7eb5",
  null
  
)

export default component.exports